export enum SearchBarValidationMessages {
  InvalidLatitudeOrLongitudeRange = 'Enter latitude between -90° and +90°, and longitude between -180° and +180°.',
  CoordinatesOutsideValidArea = 'These coordinates fall outside the valid area for the selected coordinate system.',
  CoordinateTransformFailed = 'Could not convert these coordinates. Check the values and the selected coordinate system.',
  CrsRegistrationFailed = 'Failed to load the selected coordinate system. Please try again.',
}

export enum CoordinateFieldLabel {
  Latitude = 'Latitude',
  Longitude = 'Longitude',
  Easting = 'Easting',
  Northing = 'Northing',
}
